module.exports = __webpack_public_path__ + "static/media/select.2bec20ce.svg";